import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { get } from 'lodash';
import { CATEGORIES } from '../../../services/fileUpload/uploadFile';
import Editor from '../../widgets/Editor/editor';
import { CodeEditorPanelSectionToolbar } from '../../widgets/CodeEditor/CodeEditorPanelSectionToolbar';
import { CodeEditorPanel } from '../../widgets/CodeEditor/CodeEditorPanel';
import './PagesTrackingHooks.scss';
import { connect } from 'react-redux';
import {
    CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE,
    SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG
} from '../../../constants/ActionTypes';
import { SAVE_LEVEL } from '../../../constants/Level';
import { Service } from '../../../services/Service';
import { FileService } from '../../../services/fileUpload/uploadFile';
import { clearSbemTrackingHookContentCache } from '../../../services/AssetService';
import { checkPermissions } from '../../../../lib/utils';
import { ACCESS_POINTS_GROUP } from '../../../constants/AccessPoints';

const noOp = () => {};

function onAssetSelected(section, asset) {
    this.props.setConfigField(
        `trackingHooks`,
        `${section}`,
        Service.assetUrl(
            asset.chainid,
            asset.hotelid,
            null,
            asset.hotelid ? SAVE_LEVEL.HOTEL : SAVE_LEVEL.CHAIN,
            asset.filename,
            true,
            asset.category
        )
    );
    this.setState({
        onAssetSelected: noOp
    });
}

const trackingHooksList = {
    head: {
        key: 'head',
        label: 'Head'
    },
    ON_LANDING_PAGE: {
        key: 'ON_LANDING_PAGE',
        label: 'Landing Page'
    },
    GET_HOTEL_AVAILABILITY_FINISHED: {
        key: 'GET_HOTEL_AVAILABILITY_FINISHED',
        label: 'Hotels Tracking Hook'
    },
    GET_PRODUCT_AVAILABILITY_RESPONDED: {
        key: 'GET_PRODUCT_AVAILABILITY_RESPONDED',
        label: 'Room Availability Success'
    },
    RETAIL_PRODUCT_DETAILS: {
        key: 'RETAIL_PRODUCT_DETAILS',
        label: 'Product Details'
    },
    CREATE_RESERVATION_SUCCESS: {
        key: 'CREATE_RESERVATION_SUCCESS',
        label: 'Create Reservation Success'
    },
    GET_ADD_ONS_SUCCESS: {
        key: 'GET_ADD_ONS_SUCCESS',
        label: 'Add Ons Success'
    },
    ON_CART: {
        key: 'ON_CART',
        label: 'Cart'
    },
    ON_CHECKOUT: {
        key: 'ON_CHECKOUT',
        label: 'Checkout'
    },
    ON_REVIEW: {
        key: 'ON_REVIEW',
        label: 'Review'
    },
    CONFIRM_RESERVATION_SUCCESS: {
        key: 'CONFIRM_RESERVATION_SUCCESS',
        label: 'Confirm Reservations Success'
    }
};

class PagesTrackingHooks extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: '',
            currentlyEdited: '',
            hookRef: null,
            onAssetSelected: noOp,
            value: ''
        };
    }

    componentDidMount() {
        if (this.props.onIndex) {
            this.props.onIndex(ReactDOM.findDOMNode(this).innerText);
        }
    }

    setValue(value) {
        this.setState({
            value
        });
    }

    onSave(value) {
        const { chainId, hotelId, level } = this.props;
        const file = new File([value], this.state.file ? this.state.file.split('/').pop() : this.generateFileName());

        FileService.upload(chainId, hotelId, level, Object.assign(file, { override: true }), () => {}, {
            category: CATEGORIES.TRACKING
        }).then(response => {
            const file = get(response.data, 'FilesResult.FilePath', '').replace('/opt/', '');
            this.props.setConfigField(`trackingHooks`, `${this.state.currentlyEdited}`, file);
            this.setState({
                file
            });
            clearSbemTrackingHookContentCache(chainId, hotelId);
        });
    }

    generateFileName() {
        const { configCode } = this.props;
        return `${configCode}_${this.getActiveTitle()
            .replace(':', '')
            .replace(/[\s-]+/g, '-')
            .toLowerCase()}.js`;
    }

    renderTrackingHook(hookLabel, hookKey) {
        const { trackingHooks } = this.props;
        const value = get(trackingHooks, `${hookKey}`, '');

        return (
            <div className={`spark-panel spark-mar-b-1`} key={`spark-${hookKey}`}>
                <div
                    className="spark-panel__header spark-pad-1"
                    role="heading"
                    tabIndex="0"
                    aria-expanded="false"
                    aria-controls={`${hookKey}-sections`}
                    ref={node => (trackingHooksList[hookKey].ref = node)}
                >
                    <CodeEditorPanelSectionToolbar
                        permission={this.props.hasAccess}
                        renderButtons={true}
                        label={hookLabel}
                        file={value}
                        path={hookKey}
                        onSelect={() => {
                            if (this.props.hasAccess.edit) {
                                this.setState(
                                    {
                                        onAssetSelected: onAssetSelected.bind(this, hookKey)
                                    },
                                    () => this.editorPanelRef.getWrappedInstance().openAssetBrowser()
                                );
                            }
                        }}
                        onEdit={() => {
                            this.setState(
                                {
                                    file: value,
                                    value: '',
                                    currentlyEdited: hookKey,
                                    hookRef: trackingHooksList[hookKey].ref
                                },
                                () => {
                                    if (value) {
                                        FileService.getByName(this.state.file).then(response => {
                                            this.setState({
                                                value: response.data
                                            });
                                        });
                                    }
                                }
                            );
                        }}
                        onClear={() => {
                            if (this.props.hasAccess.edit) {
                                this.props.setConfigField(`trackingHooks`, `${hookKey}`, '');
                            }
                        }}
                    >
                        <div>{value instanceof Object ? '' : value}</div>
                    </CodeEditorPanelSectionToolbar>
                </div>
            </div>
        );
    }

    getActiveTitle() {
        return get(trackingHooksList, [this.state.currentlyEdited, 'label']);
    }

    render() {
        const { languageCode } = this.props;
        return (
            <div className="ThemeColors Theme-Content spark-mar-t-1">
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>
                        <h1>Tracking hooks</h1>
                    </span>
                </div>
                <div className="subpages-main-content">
                    <div className="spark-panel spark-margin-top">
                        <div className="spark-panel__content">
                            <div className="row">
                                <div className="col-xs-3">
                                    <div
                                        ref={node => (this.hooksRef = node)}
                                        className={'custom-content tracking-hooks-list'}
                                    >
                                        {Object.entries(trackingHooksList).map(([hookKey, hook]) =>
                                            this.renderTrackingHook(hook.label, hookKey)
                                        )}
                                    </div>
                                </div>
                                <div className="hideComponent">
                                    <CodeEditorPanel
                                        ref={node => (this.editorPanelRef = node)}
                                        permission={this.props.hasAccess}
                                        languageCode={languageCode}
                                        file={this.state.file}
                                        category={CATEGORIES.TRACKING}
                                        title={this.getActiveTitle()}
                                        caretTarget={this.state.hookRef}
                                        editedSection={this.state.currentlyEdited}
                                        onSave={(saveLanguageCode, hookKey, response) => {
                                            const file = get(response.data, 'FilesResult.FilePath', '').replace(
                                                '/opt/',
                                                ''
                                            );
                                            this.props.setConfigField(`trackingHooks`, `${hookKey}`, file);
                                            this.setState({
                                                file
                                            });
                                            clearSbemTrackingHookContentCache(this.props.chainId, this.props.hotelId);
                                        }}
                                        onCancel={() => {
                                            this.setState({
                                                file: '',
                                                currentlyEdited: '',
                                                hookRef: null
                                            });
                                        }}
                                        onAssetSelected={this.state.onAssetSelected}
                                        generateFileName={() => {
                                            const { configCode } = this.props;
                                            return `${configCode}_${this.getActiveTitle()
                                                .replace(':', '')
                                                .replace(/[\s-]+/g, '-')
                                                .toLowerCase()}.js`;
                                        }}
                                    />
                                </div>
                                <div className="col-xs-9">
                                    {this.state.currentlyEdited ? (
                                        <Editor
                                            title={this.getActiveTitle()}
                                            editedSection={this.state.currentlyEdited}
                                            value={this.state.value}
                                            disabled={!this.props.hasAccess.edit}
                                            onChange={value => this.setValue(value)}
                                            onSave={value => this.onSave(value)}
                                        />
                                    ) : (
                                        <h3>Please select a tracking hook from a menu on a left</h3>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

PagesTrackingHooks.propTypes = {
    children: PropTypes.element
};

const mapStateToProps = state => {
    return {
        trackingHooks: state.app.data.configuration.configuration.currentConfigCopy.trackingHooks,
        configCode: state.app.data.configuration.configuration.configCode,
        level: state.app.selected.level,
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        themeCode: state.app.selected.code,
        hasAccess: checkPermissions(state, ACCESS_POINTS_GROUP.TRACKING_HOOKS)
    };
};
const mapDispatchToProps = dispatch => ({
    setConfigField: (parent, code, value) => {
        dispatch({
            type: SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG,
            parent: parent,
            code: code,
            value: value
        });
    },
    changeCustomContentLanguageCode: code => {
        dispatch({ type: CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE, languageCode: code });
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(PagesTrackingHooks);



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesTrackingHooks.js